import type { FaireProductEntity } from "../../entity_types/product";

export const p_r3jb7xvdwb: FaireProductEntity = {
  token: "p_r3jb7xvdwb",
  type: "product",
  name: "SDJ EVIL EYE ASSORTED EARRING SET, YE 5783",
  brandToken: "b_gk6kg6d4dw",
  brandName: "JOIA ACCESSORIES",
  imageUrl:
    "https://cdn.faire.com/fastly/10858b30801955440c589fcbd68470493868d96c73e98740f81b1bad9c6fd017.jpeg",
  galleryImageUrls: [],
  priceDollars: 10.05,
  description:
    "Our SDJ Evil Eye Assorted Earring Set, YE 5783, from Joia Accessories is a testament to our commitment to offering the largest and most diverse selection in the industry. This set captures the latest fashion trends, ensuring you stay ahead of the curve. It's more than just jewelry, it's a style statement. Stand out with this unique set, perfect for any occasion.",
  tags: [],
  msrpDollars: 20.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:42.762Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
